module.exports = __webpack_public_path__ + "static/media/YTIGateLink.efd128d7.png";